import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var NotificationIcon = function NotificationIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.939A6.003 6.003 0 0 1 18 9.75v5.823l1.42 2.842a.75.75 0 0 1-.67 1.085h-3.285a3.5 3.5 0 0 1-6.93 0H5.25a.75.75 0 0 1-.67-1.085L6 15.573V9.75a6.003 6.003 0 0 1 4.5-5.811V3a1.5 1.5 0 0 1 3 0v.939zm.437 15.561h-3.874a2 2 0 0 0 3.874 0zM15.5 18h2.036l-.957-1.915a.75.75 0 0 1-.079-.335v-6a4.5 4.5 0 1 0-9 0v6a.75.75 0 0 1-.08.335L6.465 18H15.5z"
  }));
};

NotificationIcon.displayName = 'NotificationIcon';
export default NotificationIcon;